import React, { ComponentType } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import userSelectors from 'modules/users/selectors';
import { roles } from 'constants/index';
import { routes } from 'configs/navigation';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { showSnackbarError } from 'modules/application/slice';
import { getDictionary } from 'services/i18n/i18n';

export const EnsureAdminAccess = (Component: ComponentType): ComponentType => {
  const Wrapper: React.FC = () => {
    const dispatch = useAppDispatch();
    const dictionary = getDictionary();
    const currentUser = useSelector(userSelectors.selectCurrentUser);

    if (currentUser.role === roles.admin) {
      return <Component />;
    }

    dispatch(showSnackbarError({ message: dictionary.errors.user_has_not_permission }));
    return <Redirect to={routes.root.routes.app.path} />;
  };

  return Wrapper;
};
